import React, { useState, useEffect, useCallback } from 'react'
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { ReactComponent as IconHead2 } from "../../../assets/icon/icon-head-2.svg"
import { DatePicker } from 'antd'
import moment from "moment"
import StaticsOrderHourTable from './StaticsOrderHourTable'
import { staticsOrderByPeriod } from "../../../services/api/apiOrdersReport"
import downloadCsv from '../../../components/ExportCSV/downloadCsv'


const StaticsOrderHourPage = () => {

    const [loading, setLoading] = useState(false)
    const [dateFrom, setDateFrom] = useState(moment())
    const [dateTo, setDateTo] = useState(moment())
    const [data, setData] = useState([])
    const [error, setError] = useState('')

    const _fetchData = useCallback(async () => {
        setLoading(true)
        setError('')
        setData([])

        try {
            const params = {
                date_from: moment(dateFrom).format('DD/MM/YYYY'),
                date_to: moment(dateTo).format('DD/MM/YYYY'),
            }
            const { data: response } = await staticsOrderByPeriod(params)
            const { success, data, message } = response

            if (!success) {
                setLoading(false)
                setError(message)
                return
            }

            const isSameDay = moment(dateFrom).isSame(moment(dateTo), 'day')
            const {items = []} = data || {}

            const newData = items.map((item, index) => {
                if (isSameDay) {
                    return {
                        ...item,
                        phase_time: index > 9
                            ? `${index}:00 - ${index}:59`
                            : `0${index}:00 - 0${index}:59`
                    }
                } else {
                    return {
                        ...item,
                        phase_time: item.time
                    }
                }
            })

            setLoading(false)
            setData(newData)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }, [dateFrom, dateTo])

    useEffect(() => {
        _fetchData()
    }, [_fetchData])

    const _handleExport = () => {
        downloadCsv(data, {
            mapCols: {
                phase_time: 'Time',
                totalOrders: 'Total Orders',
                totalItems: 'Total Items',
                totalItemsMCLab: 'Item MC Lab'
            },
            prefix: [`static-order-hour`].filter(Boolean).join('-') + '-',
        })
    }

    return (
        <Row className='text-center'>
            <Col md={12}>
                <div className="StaticsOrderHourPage StaticsCreatedPage">
                    <Card>
                        <CardHeader className="CardHeader text-white header-elements-inline">
                            <h2 className="card-title d-flex align-items-center">
                                <IconHead2 />
                                Thống kê đơn theo giờ
                            </h2>
                        </CardHeader>
                        <CardBody>
                            <div className="SearchDateTime d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <span>Từ ngày</span>
                                    <div className='DatePicker ml-2'>
                                        <DatePicker
                                            value={dateFrom}
                                            format="DD/MM/YYYY"
                                            onChange={(d) => {
                                                setDateFrom(d)
                                                if (d && dateTo && d.isAfter(dateTo, 'day')) setDateTo(d)
                                            }}
                                            allowClear={false}
                                            className='mr-2'
                                        />
                                    </div>
                                    <span className='ml-2'>Đến ngày</span>
                                    <div className='DatePicker ml-2'>
                                        <DatePicker
                                            value={dateTo}
                                            format="DD/MM/YYYY"
                                            onChange={(d) => setDateTo(d)}
                                            allowClear={false}
                                            className='mr-2'
                                            disabledDate={(current) => current && current < dateFrom.clone().startOf('day')}
                                        />
                                        <i className={['BtnRefresh fa fa-refresh', loading && 'disabled spinner'].filter(Boolean).join(' ')}
                                           onClick={_fetchData} title={'Tải lại'}/>
                                    </div>
                                </div>
                                <div className="Export d-flex align-items-center">
                                    <button type="default" className='btn btn-primary' disabled={!data.length} onClick={_handleExport}>
                                        Export
                                    </button>
                                </div>
                            </div>
                            <div className="TableStatics d-flex justify-content-between">
                                <StaticsOrderHourTable data={!!data ? data : []} loading={loading} error={error} />
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </Col>
        </Row>
    )
}

export default StaticsOrderHourPage
